export default __webpack_public_path__ + "static/pinkonblue-3d164de0ef530e21855530c6b307d432.png";